export default {
	APPLE_CLIENT_ID: process.env.REACT_APP_APPLE_CLIENT_ID,
	APPLE_TEAM_ID: process.env.REACT_APP_APPLE_TEAM_ID,
	APPLE_KEY_ID: process.env.REACT_APP_KEY_ID,

	APPLE_REDIRECT_URL: process.env.REACT_APP_APPLE_REDIRECT_URL,
	APPLE_SCOPE: process.env.REACT_APP_APPLE_SCOPE
};
